import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'highlight' })
export class HighlightTextPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(text: string, searchedText: string): SafeHtml {
    if (!searchedText?.trim()) return text;

    const trimmed = searchedText.trim();
    const searchTerms = trimmed.split(/\s+/);

    const escapedTerms = searchTerms.map(term => this.escapeRegExp(term));
    const regexPattern = `(${escapedTerms.join('|')})`;
    const regex = new RegExp(regexPattern, 'gi');

    const highlightedText = text.replace(regex, match => `<span class="cipo--text--highlight">${match}</span>`);

    // Use DomSanitizer to mark the content as safe
    return this.sanitizer.bypassSecurityTrustHtml(highlightedText);
  }

  private escapeRegExp(word: string): string {
    return word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
}
